import { imgSrc } from "../../lib/api";

export const MerchImage = ({ m, small = false }) =>
  m.image_url ? (
    <img src={imgSrc(m.image_url)} alt={m.name} className="w-full h-full object-cover" />
  ) : (
    <div data-testid={`merch-coming-soon-${m.id || m.ref_id}`} className="w-full h-full flex items-center justify-center bg-[#0d0f14] border border-dashed border-[#00d436]/40 rounded-[inherit]">
      <span className={`font-cond uppercase font-black tracking-widest text-lime text-center leading-none ${small ? "text-[10px]" : "text-3xl sm:text-4xl"}`}>
        Coming<br />soon
      </span>
    </div>
  );
